module.exports = __webpack_public_path__ + "static/media/acorn.4b876f87.svg";